"use strict";

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApolloClientManager = void 0;

var globalTypes_1 = require("../../gqlTypes/globalTypes");

var AuthMutations = __importStar(require("../../mutations/auth"));

var UserMutations = __importStar(require("../../mutations/user"));

var CheckoutMutations = __importStar(require("../../mutations/checkout"));

var CheckoutQueries = __importStar(require("../../queries/checkout"));

var UserQueries = __importStar(require("../../queries/user"));

var utils_1 = require("../../utils");

var ApolloClientManager = /*#__PURE__*/_createClass(function ApolloClientManager(client) {
  var _this = this;

  _classCallCheck(this, ApolloClientManager);

  this.subscribeToUserChange = function (next, error, complete) {
    _this.client.watchQuery({
      fetchPolicy: "cache-only",
      query: UserQueries.getUserDetailsQuery
    }).subscribe(function (value) {
      var _a;

      return next((_a = value.data) === null || _a === void 0 ? void 0 : _a.me);
    }, error, complete);
  };

  this.getUser = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$this$client$qu, data, errors;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.client.query({
                fetchPolicy: "network-only",
                query: UserQueries.getUserDetailsQuery
              });

            case 2:
              _yield$this$client$qu = _context.sent;
              data = _yield$this$client$qu.data;
              errors = _yield$this$client$qu.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", {
                error: errors
              });

            case 7:
              return _context.abrupt("return", {
                data: data === null || data === void 0 ? void 0 : data.me
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  this.registerAccount = function (email, password, redirectUrl) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _a, _b, _yield$this$client$mu, data, errors;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.client.mutate({
                fetchPolicy: "no-cache",
                mutation: UserMutations.registerAccount,
                variables: {
                  email: email,
                  password: password,
                  redirectUrl: redirectUrl
                }
              });

            case 2:
              _yield$this$client$mu = _context2.sent;
              data = _yield$this$client$mu.data;
              errors = _yield$this$client$mu.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", {
                error: errors
              });

            case 7:
              if (!((_a = data === null || data === void 0 ? void 0 : data.accountRegister) === null || _a === void 0 ? void 0 : _a.accountErrors.length)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", {
                error: data.accountRegister.accountErrors
              });

            case 9:
              return _context2.abrupt("return", {
                data: {
                  requiresConfirmation: (_b = data === null || data === void 0 ? void 0 : data.accountRegister) === null || _b === void 0 ? void 0 : _b.requiresConfirmation
                }
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  this.resetPasswordRequest = function (email, redirectUrl) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _c, _yield$this$client$mu2, data, errors;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.client.mutate({
                fetchPolicy: "no-cache",
                mutation: UserMutations.resetPasswordRequest,
                variables: {
                  email: email,
                  redirectUrl: redirectUrl
                }
              });

            case 2:
              _yield$this$client$mu2 = _context3.sent;
              data = _yield$this$client$mu2.data;
              errors = _yield$this$client$mu2.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", {
                error: errors
              });

            case 7:
              if (!((_c = data === null || data === void 0 ? void 0 : data.requestPasswordReset) === null || _c === void 0 ? void 0 : _c.accountErrors.length)) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return", {
                error: data.requestPasswordReset.accountErrors
              });

            case 9:
              return _context3.abrupt("return", {});

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  this.signIn = function (email, password) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _d, _e, _f, _g, _yield$this$client$mu3, data, errors;

      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.client.mutate({
                fetchPolicy: "no-cache",
                mutation: AuthMutations.tokenAuthMutation,
                variables: {
                  email: email,
                  password: password
                }
              });

            case 2:
              _yield$this$client$mu3 = _context4.sent;
              data = _yield$this$client$mu3.data;
              errors = _yield$this$client$mu3.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", {
                error: errors
              });

            case 7:
              if (!((_d = data === null || data === void 0 ? void 0 : data.tokenCreate) === null || _d === void 0 ? void 0 : _d.errors.length)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", {
                error: data.tokenCreate.errors
              });

            case 9:
              return _context4.abrupt("return", {
                data: {
                  csrfToken: (_e = data === null || data === void 0 ? void 0 : data.tokenCreate) === null || _e === void 0 ? void 0 : _e.csrfToken,
                  token: (_f = data === null || data === void 0 ? void 0 : data.tokenCreate) === null || _f === void 0 ? void 0 : _f.token,
                  user: (_g = data === null || data === void 0 ? void 0 : data.tokenCreate) === null || _g === void 0 ? void 0 : _g.user
                }
              });

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));
  };

  this.signOut = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.client.resetStore();

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));
  };

  this.verifySignInToken = function (_ref) {
    var token = _ref.token;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _h, _j, _k, _l, _yield$this$client$mu4, data, errors;

      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.client.mutate({
                fetchPolicy: "no-cache",
                mutation: AuthMutations.tokenVeryficationMutation,
                variables: {
                  token: token
                }
              });

            case 2:
              _yield$this$client$mu4 = _context6.sent;
              data = _yield$this$client$mu4.data;
              errors = _yield$this$client$mu4.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context6.next = 7;
                break;
              }

              return _context6.abrupt("return", {
                error: errors
              });

            case 7:
              if (!((_h = data === null || data === void 0 ? void 0 : data.tokenVerify) === null || _h === void 0 ? void 0 : _h.errors.length)) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", {
                error: data.tokenVerify.errors
              });

            case 9:
              return _context6.abrupt("return", {
                data: {
                  isValid: (_j = data === null || data === void 0 ? void 0 : data.tokenVerify) === null || _j === void 0 ? void 0 : _j.isValid,
                  payload: (_k = data === null || data === void 0 ? void 0 : data.tokenVerify) === null || _k === void 0 ? void 0 : _k.payload,
                  user: (_l = data === null || data === void 0 ? void 0 : data.tokenVerify) === null || _l === void 0 ? void 0 : _l.user
                }
              });

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));
  };

  this.refreshSignInToken = function (_ref2) {
    var csrfToken = _ref2.csrfToken,
        refreshToken = _ref2.refreshToken;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var _m, _o, _p, _yield$this$client$mu5, data, errors;

      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.client.mutate({
                fetchPolicy: "no-cache",
                mutation: AuthMutations.tokenRefreshMutation,
                variables: {
                  csrfToken: csrfToken,
                  refreshToken: refreshToken
                }
              });

            case 2:
              _yield$this$client$mu5 = _context7.sent;
              data = _yield$this$client$mu5.data;
              errors = _yield$this$client$mu5.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context7.next = 7;
                break;
              }

              return _context7.abrupt("return", {
                error: errors
              });

            case 7:
              if (!((_m = data === null || data === void 0 ? void 0 : data.tokenRefresh) === null || _m === void 0 ? void 0 : _m.errors.length)) {
                _context7.next = 9;
                break;
              }

              return _context7.abrupt("return", {
                error: data.tokenRefresh.errors
              });

            case 9:
              return _context7.abrupt("return", {
                data: {
                  token: (_o = data === null || data === void 0 ? void 0 : data.tokenRefresh) === null || _o === void 0 ? void 0 : _o.token,
                  user: (_p = data === null || data === void 0 ? void 0 : data.tokenRefresh) === null || _p === void 0 ? void 0 : _p.user
                }
              });

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));
  };

  this.getCheckout = function (isUserSignedIn, channel, checkoutToken) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var _this2 = this;

      var checkout;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return new Promise(function (resolve, reject) {
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                  var _q, token, _yield$this$client$qu2, data, errors, _data$me$checkoutToke, observable;

                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          token = checkoutToken;

                          if (!isUserSignedIn) {
                            _context8.next = 8;
                            break;
                          }

                          _context8.next = 4;
                          return this.client.query({
                            fetchPolicy: "network-only",
                            query: CheckoutQueries.userCheckoutTokenList,
                            variables: {
                              channel: channel
                            }
                          });

                        case 4:
                          _yield$this$client$qu2 = _context8.sent;
                          data = _yield$this$client$qu2.data;
                          errors = _yield$this$client$qu2.errors;

                          if (errors === null || errors === void 0 ? void 0 : errors.length) {
                            reject(errors);
                          } else if ((_q = data.me) === null || _q === void 0 ? void 0 : _q.checkoutTokens) {
                            _data$me$checkoutToke = _slicedToArray(data.me.checkoutTokens, 1);
                            token = _data$me$checkoutToke[0];
                          }

                        case 8:
                          if (token) {
                            observable = this.client.watchQuery({
                              fetchPolicy: "network-only",
                              query: CheckoutQueries.checkoutDetails,
                              variables: {
                                token: token
                              }
                            });
                            observable.subscribe(function (result) {
                              var data = result.data,
                                  errors = result.errors;

                              if (errors === null || errors === void 0 ? void 0 : errors.length) {
                                reject(errors);
                              } else {
                                resolve(data.checkout);
                              }
                            }, function (error) {
                              reject(error);
                            });
                          } else {
                            resolve(null);
                          }

                        case 9:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8, this);
                }));
              });

            case 3:
              checkout = _context9.sent;

              if (!checkout) {
                _context9.next = 6;
                break;
              }

              return _context9.abrupt("return", {
                data: this.constructCheckoutModel(checkout)
              });

            case 6:
              _context9.next = 11;
              break;

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              return _context9.abrupt("return", {
                error: _context9.t0
              });

            case 11:
              return _context9.abrupt("return", {});

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this, [[0, 8]]);
    }));
  };

  this.getRefreshedCheckoutLines = function (checkoutlines, channel) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var idsOfMissingVariants, linesWithProperVariant, variants, observable, linesWithMissingVariantUpdated, linesWithProperVariantUpdated;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              idsOfMissingVariants = checkoutlines === null || checkoutlines === void 0 ? void 0 : checkoutlines.filter(function (line) {
                return !line.variant || !line.totalPrice;
              }).map(function (line) {
                return line.variant.id;
              });
              linesWithProperVariant = (checkoutlines === null || checkoutlines === void 0 ? void 0 : checkoutlines.filter(function (line) {
                return line.variant && line.totalPrice;
              })) || [];

              if (!(idsOfMissingVariants && idsOfMissingVariants.length)) {
                _context10.next = 13;
                break;
              }

              _context10.prev = 3;
              observable = this.client.watchQuery({
                query: CheckoutQueries.checkoutProductVariants,
                variables: {
                  channel: channel,
                  ids: idsOfMissingVariants
                }
              });
              _context10.next = 7;
              return new Promise(function (resolve, reject) {
                observable.subscribe(function (result) {
                  var data = result.data,
                      errors = result.errors;

                  if (errors === null || errors === void 0 ? void 0 : errors.length) {
                    reject(errors);
                  } else {
                    resolve(data.productVariants);
                  }
                }, function (error) {
                  reject(error);
                });
              });

            case 7:
              variants = _context10.sent;
              _context10.next = 13;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](3);
              return _context10.abrupt("return", {
                error: _context10.t0
              });

            case 13:
              linesWithMissingVariantUpdated = variants ? variants.edges.map(function (edge) {
                var _a;

                var existingLine = checkoutlines === null || checkoutlines === void 0 ? void 0 : checkoutlines.find(function (line) {
                  return line.variant.id === edge.node.id;
                });
                var variantPricing = (_a = edge.node.pricing) === null || _a === void 0 ? void 0 : _a.price;
                var totalPrice = variantPricing ? {
                  gross: Object.assign(Object.assign({}, variantPricing.gross), {
                    amount: variantPricing.gross.amount * ((existingLine === null || existingLine === void 0 ? void 0 : existingLine.quantity) || 0)
                  }),
                  net: Object.assign(Object.assign({}, variantPricing.net), {
                    amount: variantPricing.net.amount * ((existingLine === null || existingLine === void 0 ? void 0 : existingLine.quantity) || 0)
                  })
                } : null;
                return {
                  id: existingLine === null || existingLine === void 0 ? void 0 : existingLine.id,
                  quantity: (existingLine === null || existingLine === void 0 ? void 0 : existingLine.quantity) || 0,
                  totalPrice: totalPrice,
                  variant: {
                    attributes: edge.node.attributes,
                    id: edge.node.id,
                    name: edge.node.name,
                    pricing: edge.node.pricing,
                    product: edge.node.product,
                    quantityAvailable: edge.node.quantityAvailable,
                    sku: edge.node.sku
                  }
                };
              }) : [];
              linesWithProperVariantUpdated = linesWithProperVariant.map(function (line) {
                var _a;

                var variantPricing = (_a = line.variant.pricing) === null || _a === void 0 ? void 0 : _a.price;
                var totalPrice = variantPricing ? {
                  gross: Object.assign(Object.assign({}, variantPricing.gross), {
                    amount: variantPricing.gross.amount * line.quantity
                  }),
                  net: Object.assign(Object.assign({}, variantPricing.net), {
                    amount: variantPricing.net.amount * line.quantity
                  })
                } : null;
                return {
                  id: line.id,
                  quantity: line.quantity,
                  totalPrice: totalPrice,
                  variant: line.variant
                };
              });
              return _context10.abrupt("return", {
                data: [].concat(_toConsumableArray(linesWithMissingVariantUpdated), _toConsumableArray(linesWithProperVariantUpdated))
              });

            case 16:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this, [[3, 10]]);
    }));
  };

  this.createCheckout = function (email, lines, channel, shippingAddress, billingAddress) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var _r, _s, _t, _u, _v, variables, _yield$this$client$mu6, data, errors;

      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              variables = {
                checkoutInput: {
                  billingAddress: billingAddress && {
                    city: billingAddress.city,
                    companyName: billingAddress.companyName,
                    country: globalTypes_1.CountryCode[(_r = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country) === null || _r === void 0 ? void 0 : _r.code],
                    countryArea: billingAddress.countryArea,
                    firstName: billingAddress.firstName,
                    lastName: billingAddress.lastName,
                    phone: billingAddress.phone,
                    postalCode: billingAddress.postalCode,
                    streetAddress1: billingAddress.streetAddress1,
                    streetAddress2: billingAddress.streetAddress2
                  },
                  channel: channel,
                  email: email,
                  lines: lines,
                  shippingAddress: shippingAddress && {
                    city: shippingAddress.city,
                    companyName: shippingAddress.companyName,
                    country: globalTypes_1.CountryCode[(_s = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country) === null || _s === void 0 ? void 0 : _s.code],
                    countryArea: shippingAddress.countryArea,
                    firstName: shippingAddress.firstName,
                    lastName: shippingAddress.lastName,
                    phone: shippingAddress.phone,
                    postalCode: shippingAddress.postalCode,
                    streetAddress1: shippingAddress.streetAddress1,
                    streetAddress2: shippingAddress.streetAddress2
                  }
                }
              };
              _context11.next = 4;
              return this.client.mutate({
                mutation: CheckoutMutations.createCheckoutMutation,
                variables: variables
              });

            case 4:
              _yield$this$client$mu6 = _context11.sent;
              data = _yield$this$client$mu6.data;
              errors = _yield$this$client$mu6.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context11.next = 9;
                break;
              }

              return _context11.abrupt("return", {
                error: errors
              });

            case 9:
              if (!((_t = data === null || data === void 0 ? void 0 : data.checkoutCreate) === null || _t === void 0 ? void 0 : _t.errors.length)) {
                _context11.next = 11;
                break;
              }

              return _context11.abrupt("return", {
                error: (_u = data === null || data === void 0 ? void 0 : data.checkoutCreate) === null || _u === void 0 ? void 0 : _u.errors
              });

            case 11:
              if (!((_v = data === null || data === void 0 ? void 0 : data.checkoutCreate) === null || _v === void 0 ? void 0 : _v.checkout)) {
                _context11.next = 13;
                break;
              }

              return _context11.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutCreate.checkout)
              });

            case 13:
              _context11.next = 18;
              break;

            case 15:
              _context11.prev = 15;
              _context11.t0 = _context11["catch"](0);
              return _context11.abrupt("return", {
                error: _context11.t0
              });

            case 18:
              return _context11.abrupt("return", {});

            case 19:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this, [[0, 15]]);
    }));
  };

  this.setCartItem = function (checkout) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var _w, _x, _y, checkoutId, lines, alteredLines, _yield$this$client$mu7, data, errors;

      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              checkoutId = checkout.id;
              lines = checkout.lines;

              if (!(checkoutId && lines)) {
                _context12.next = 21;
                break;
              }

              alteredLines = lines.map(function (line) {
                return {
                  quantity: line.quantity,
                  variantId: line.variant.id
                };
              });
              _context12.prev = 4;
              _context12.next = 7;
              return this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutLineMutation,
                variables: {
                  checkoutId: checkoutId,
                  lines: alteredLines
                }
              });

            case 7:
              _yield$this$client$mu7 = _context12.sent;
              data = _yield$this$client$mu7.data;
              errors = _yield$this$client$mu7.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context12.next = 12;
                break;
              }

              return _context12.abrupt("return", {
                error: errors
              });

            case 12:
              if (!((_w = data === null || data === void 0 ? void 0 : data.checkoutLinesUpdate) === null || _w === void 0 ? void 0 : _w.errors.length)) {
                _context12.next = 14;
                break;
              }

              return _context12.abrupt("return", {
                error: (_x = data === null || data === void 0 ? void 0 : data.checkoutLinesUpdate) === null || _x === void 0 ? void 0 : _x.errors
              });

            case 14:
              if (!((_y = data === null || data === void 0 ? void 0 : data.checkoutLinesUpdate) === null || _y === void 0 ? void 0 : _y.checkout)) {
                _context12.next = 16;
                break;
              }

              return _context12.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutLinesUpdate.checkout)
              });

            case 16:
              _context12.next = 21;
              break;

            case 18:
              _context12.prev = 18;
              _context12.t0 = _context12["catch"](4);
              return _context12.abrupt("return", {
                error: _context12.t0
              });

            case 21:
              return _context12.abrupt("return", {});

            case 22:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this, [[4, 18]]);
    }));
  };

  this.setShippingAddress = function (shippingAddress, email, checkoutId, channel) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var _z, _0, _1, _2, _3, _4, variables, _yield$this$client$mu8, data, errors;

      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              variables = {
                channel: channel,
                checkoutId: checkoutId,
                email: email,
                shippingAddress: {
                  city: shippingAddress.city,
                  companyName: shippingAddress.companyName,
                  country: globalTypes_1.CountryCode[(_z = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country) === null || _z === void 0 ? void 0 : _z.code],
                  countryArea: shippingAddress.countryArea,
                  firstName: shippingAddress.firstName,
                  lastName: shippingAddress.lastName,
                  phone: shippingAddress.phone,
                  postalCode: shippingAddress.postalCode,
                  streetAddress1: shippingAddress.streetAddress1,
                  streetAddress2: shippingAddress.streetAddress2
                }
              };
              _context13.next = 4;
              return this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutShippingAddressMutation,
                variables: variables
              });

            case 4:
              _yield$this$client$mu8 = _context13.sent;
              data = _yield$this$client$mu8.data;
              errors = _yield$this$client$mu8.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context13.next = 9;
                break;
              }

              return _context13.abrupt("return", {
                error: errors
              });

            case 9:
              if (!((_0 = data === null || data === void 0 ? void 0 : data.checkoutEmailUpdate) === null || _0 === void 0 ? void 0 : _0.errors.length)) {
                _context13.next = 11;
                break;
              }

              return _context13.abrupt("return", {
                error: (_1 = data === null || data === void 0 ? void 0 : data.checkoutEmailUpdate) === null || _1 === void 0 ? void 0 : _1.errors
              });

            case 11:
              if (!((_2 = data === null || data === void 0 ? void 0 : data.checkoutShippingAddressUpdate) === null || _2 === void 0 ? void 0 : _2.errors.length)) {
                _context13.next = 13;
                break;
              }

              return _context13.abrupt("return", {
                error: (_3 = data === null || data === void 0 ? void 0 : data.checkoutShippingAddressUpdate) === null || _3 === void 0 ? void 0 : _3.errors
              });

            case 13:
              if (!((_4 = data === null || data === void 0 ? void 0 : data.checkoutShippingAddressUpdate) === null || _4 === void 0 ? void 0 : _4.checkout)) {
                _context13.next = 15;
                break;
              }

              return _context13.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutShippingAddressUpdate.checkout)
              });

            case 15:
              return _context13.abrupt("return", {});

            case 18:
              _context13.prev = 18;
              _context13.t0 = _context13["catch"](0);
              return _context13.abrupt("return", {
                error: _context13.t0
              });

            case 21:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this, [[0, 18]]);
    }));
  };

  this.setBillingAddress = function (billingAddress, checkoutId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      var _5, _6, _7, _8, variables, _yield$this$client$mu9, data, errors;

      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              variables = {
                billingAddress: {
                  city: billingAddress.city,
                  companyName: billingAddress.companyName,
                  country: globalTypes_1.CountryCode[(_5 = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country) === null || _5 === void 0 ? void 0 : _5.code],
                  countryArea: billingAddress.countryArea,
                  firstName: billingAddress.firstName,
                  lastName: billingAddress.lastName,
                  phone: billingAddress.phone,
                  postalCode: billingAddress.postalCode,
                  streetAddress1: billingAddress.streetAddress1,
                  streetAddress2: billingAddress.streetAddress2
                },
                checkoutId: checkoutId
              };
              _context14.next = 4;
              return this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutBillingAddressMutation,
                variables: variables
              });

            case 4:
              _yield$this$client$mu9 = _context14.sent;
              data = _yield$this$client$mu9.data;
              errors = _yield$this$client$mu9.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context14.next = 9;
                break;
              }

              return _context14.abrupt("return", {
                error: errors
              });

            case 9:
              if (!((_6 = data === null || data === void 0 ? void 0 : data.checkoutBillingAddressUpdate) === null || _6 === void 0 ? void 0 : _6.errors.length)) {
                _context14.next = 11;
                break;
              }

              return _context14.abrupt("return", {
                error: (_7 = data === null || data === void 0 ? void 0 : data.checkoutBillingAddressUpdate) === null || _7 === void 0 ? void 0 : _7.errors
              });

            case 11:
              if (!((_8 = data === null || data === void 0 ? void 0 : data.checkoutBillingAddressUpdate) === null || _8 === void 0 ? void 0 : _8.checkout)) {
                _context14.next = 13;
                break;
              }

              return _context14.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutBillingAddressUpdate.checkout)
              });

            case 13:
              return _context14.abrupt("return", {});

            case 16:
              _context14.prev = 16;
              _context14.t0 = _context14["catch"](0);
              return _context14.abrupt("return", {
                error: _context14.t0
              });

            case 19:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this, [[0, 16]]);
    }));
  };

  this.setBillingAddressWithEmail = function (billingAddress, email, checkoutId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      var _9, _10, _11, _12, _13, _14, variables, _yield$this$client$mu10, data, errors;

      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              variables = {
                billingAddress: {
                  city: billingAddress.city,
                  companyName: billingAddress.companyName,
                  country: globalTypes_1.CountryCode[(_9 = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country) === null || _9 === void 0 ? void 0 : _9.code],
                  countryArea: billingAddress.countryArea,
                  firstName: billingAddress.firstName,
                  lastName: billingAddress.lastName,
                  phone: billingAddress.phone,
                  postalCode: billingAddress.postalCode,
                  streetAddress1: billingAddress.streetAddress1,
                  streetAddress2: billingAddress.streetAddress2
                },
                checkoutId: checkoutId,
                email: email
              };
              _context15.next = 4;
              return this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutBillingAddressWithEmailMutation,
                variables: variables
              });

            case 4:
              _yield$this$client$mu10 = _context15.sent;
              data = _yield$this$client$mu10.data;
              errors = _yield$this$client$mu10.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context15.next = 9;
                break;
              }

              return _context15.abrupt("return", {
                error: errors
              });

            case 9:
              if (!((_10 = data === null || data === void 0 ? void 0 : data.checkoutEmailUpdate) === null || _10 === void 0 ? void 0 : _10.errors.length)) {
                _context15.next = 11;
                break;
              }

              return _context15.abrupt("return", {
                error: (_11 = data === null || data === void 0 ? void 0 : data.checkoutEmailUpdate) === null || _11 === void 0 ? void 0 : _11.errors
              });

            case 11:
              if (!((_12 = data === null || data === void 0 ? void 0 : data.checkoutBillingAddressUpdate) === null || _12 === void 0 ? void 0 : _12.errors.length)) {
                _context15.next = 13;
                break;
              }

              return _context15.abrupt("return", {
                error: (_13 = data === null || data === void 0 ? void 0 : data.checkoutBillingAddressUpdate) === null || _13 === void 0 ? void 0 : _13.errors
              });

            case 13:
              if (!((_14 = data === null || data === void 0 ? void 0 : data.checkoutBillingAddressUpdate) === null || _14 === void 0 ? void 0 : _14.checkout)) {
                _context15.next = 15;
                break;
              }

              return _context15.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutBillingAddressUpdate.checkout)
              });

            case 15:
              return _context15.abrupt("return", {});

            case 18:
              _context15.prev = 18;
              _context15.t0 = _context15["catch"](0);
              return _context15.abrupt("return", {
                error: _context15.t0
              });

            case 21:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this, [[0, 18]]);
    }));
  };

  this.setShippingMethod = function (shippingMethodId, checkoutId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
      var _15, _16, _17, _yield$this$client$mu11, data, errors;

      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutShippingMethodMutation,
                variables: {
                  checkoutId: checkoutId,
                  shippingMethodId: shippingMethodId
                }
              });

            case 3:
              _yield$this$client$mu11 = _context16.sent;
              data = _yield$this$client$mu11.data;
              errors = _yield$this$client$mu11.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context16.next = 8;
                break;
              }

              return _context16.abrupt("return", {
                error: errors
              });

            case 8:
              if (!((_15 = data === null || data === void 0 ? void 0 : data.checkoutShippingMethodUpdate) === null || _15 === void 0 ? void 0 : _15.errors.length)) {
                _context16.next = 10;
                break;
              }

              return _context16.abrupt("return", {
                error: (_16 = data === null || data === void 0 ? void 0 : data.checkoutShippingMethodUpdate) === null || _16 === void 0 ? void 0 : _16.errors
              });

            case 10:
              if (!((_17 = data === null || data === void 0 ? void 0 : data.checkoutShippingMethodUpdate) === null || _17 === void 0 ? void 0 : _17.checkout)) {
                _context16.next = 12;
                break;
              }

              return _context16.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutShippingMethodUpdate.checkout)
              });

            case 12:
              return _context16.abrupt("return", {});

            case 15:
              _context16.prev = 15;
              _context16.t0 = _context16["catch"](0);
              return _context16.abrupt("return", {
                error: _context16.t0
              });

            case 18:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this, [[0, 15]]);
    }));
  };

  this.addPromoCode = function (promoCode, checkoutId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      var _18, _19, _20, _yield$this$client$mu12, data, errors;

      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return this.client.mutate({
                mutation: CheckoutMutations.addCheckoutPromoCode,
                variables: {
                  checkoutId: checkoutId,
                  promoCode: promoCode
                }
              });

            case 3:
              _yield$this$client$mu12 = _context17.sent;
              data = _yield$this$client$mu12.data;
              errors = _yield$this$client$mu12.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context17.next = 8;
                break;
              }

              return _context17.abrupt("return", {
                error: errors
              });

            case 8:
              if (!((_18 = data === null || data === void 0 ? void 0 : data.checkoutAddPromoCode) === null || _18 === void 0 ? void 0 : _18.errors.length)) {
                _context17.next = 10;
                break;
              }

              return _context17.abrupt("return", {
                error: (_19 = data === null || data === void 0 ? void 0 : data.checkoutAddPromoCode) === null || _19 === void 0 ? void 0 : _19.errors
              });

            case 10:
              if (!((_20 = data === null || data === void 0 ? void 0 : data.checkoutAddPromoCode) === null || _20 === void 0 ? void 0 : _20.checkout)) {
                _context17.next = 12;
                break;
              }

              return _context17.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutAddPromoCode.checkout)
              });

            case 12:
              return _context17.abrupt("return", {});

            case 15:
              _context17.prev = 15;
              _context17.t0 = _context17["catch"](0);
              return _context17.abrupt("return", {
                error: _context17.t0
              });

            case 18:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this, [[0, 15]]);
    }));
  };

  this.removePromoCode = function (promoCode, checkoutId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      var _21, _22, _23, _yield$this$client$mu13, data, errors;

      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return this.client.mutate({
                mutation: CheckoutMutations.removeCheckoutPromoCode,
                variables: {
                  checkoutId: checkoutId,
                  promoCode: promoCode
                }
              });

            case 3:
              _yield$this$client$mu13 = _context18.sent;
              data = _yield$this$client$mu13.data;
              errors = _yield$this$client$mu13.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context18.next = 8;
                break;
              }

              return _context18.abrupt("return", {
                error: errors
              });

            case 8:
              if (!((_21 = data === null || data === void 0 ? void 0 : data.checkoutRemovePromoCode) === null || _21 === void 0 ? void 0 : _21.errors.length)) {
                _context18.next = 10;
                break;
              }

              return _context18.abrupt("return", {
                error: (_22 = data === null || data === void 0 ? void 0 : data.checkoutRemovePromoCode) === null || _22 === void 0 ? void 0 : _22.errors
              });

            case 10:
              if (!((_23 = data === null || data === void 0 ? void 0 : data.checkoutRemovePromoCode) === null || _23 === void 0 ? void 0 : _23.checkout)) {
                _context18.next = 12;
                break;
              }

              return _context18.abrupt("return", {
                data: this.constructCheckoutModel(data.checkoutRemovePromoCode.checkout)
              });

            case 12:
              return _context18.abrupt("return", {});

            case 15:
              _context18.prev = 15;
              _context18.t0 = _context18["catch"](0);
              return _context18.abrupt("return", {
                error: _context18.t0
              });

            case 18:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this, [[0, 15]]);
    }));
  };

  this.createPayment = function (_ref3) {
    var amount = _ref3.amount,
        checkoutId = _ref3.checkoutId,
        gateway = _ref3.gateway,
        token = _ref3.token,
        returnUrl = _ref3.returnUrl;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      var _24, _25, _26, variables, _yield$this$client$mu14, data, errors;

      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              variables = {
                checkoutId: checkoutId,
                paymentInput: {
                  amount: amount,
                  gateway: gateway,
                  returnUrl: returnUrl,
                  token: token
                }
              };
              _context19.next = 4;
              return this.client.mutate({
                mutation: CheckoutMutations.createCheckoutPaymentMutation,
                variables: variables
              });

            case 4:
              _yield$this$client$mu14 = _context19.sent;
              data = _yield$this$client$mu14.data;
              errors = _yield$this$client$mu14.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context19.next = 9;
                break;
              }

              return _context19.abrupt("return", {
                error: errors
              });

            case 9:
              if (!((_24 = data === null || data === void 0 ? void 0 : data.checkoutPaymentCreate) === null || _24 === void 0 ? void 0 : _24.errors.length)) {
                _context19.next = 11;
                break;
              }

              return _context19.abrupt("return", {
                error: (_25 = data === null || data === void 0 ? void 0 : data.checkoutPaymentCreate) === null || _25 === void 0 ? void 0 : _25.errors
              });

            case 11:
              if (!((_26 = data === null || data === void 0 ? void 0 : data.checkoutPaymentCreate) === null || _26 === void 0 ? void 0 : _26.payment)) {
                _context19.next = 13;
                break;
              }

              return _context19.abrupt("return", {
                data: this.constructPaymentModel(data.checkoutPaymentCreate.payment)
              });

            case 13:
              return _context19.abrupt("return", {});

            case 16:
              _context19.prev = 16;
              _context19.t0 = _context19["catch"](0);
              return _context19.abrupt("return", {
                error: _context19.t0
              });

            case 19:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this, [[0, 16]]);
    }));
  };

  this.completeCheckout = function (_ref4) {
    var checkoutId = _ref4.checkoutId,
        paymentData = _ref4.paymentData,
        redirectUrl = _ref4.redirectUrl,
        storeSource = _ref4.storeSource;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
      var _27, _28, paymentDataString, _yield$this$client$mu15, data, errors;

      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              paymentDataString = paymentData && JSON.stringify(paymentData);
              _context20.next = 4;
              return this.client.mutate({
                mutation: CheckoutMutations.completeCheckoutMutation,
                variables: {
                  checkoutId: checkoutId,
                  paymentData: paymentDataString,
                  redirectUrl: redirectUrl,
                  storeSource: storeSource
                }
              });

            case 4:
              _yield$this$client$mu15 = _context20.sent;
              data = _yield$this$client$mu15.data;
              errors = _yield$this$client$mu15.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context20.next = 9;
                break;
              }

              return _context20.abrupt("return", {
                error: errors
              });

            case 9:
              if (!((_27 = data === null || data === void 0 ? void 0 : data.checkoutComplete) === null || _27 === void 0 ? void 0 : _27.errors.length)) {
                _context20.next = 11;
                break;
              }

              return _context20.abrupt("return", {
                error: (_28 = data === null || data === void 0 ? void 0 : data.checkoutComplete) === null || _28 === void 0 ? void 0 : _28.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : data.checkoutComplete)) {
                _context20.next = 13;
                break;
              }

              return _context20.abrupt("return", {
                data: data.checkoutComplete
              });

            case 13:
              return _context20.abrupt("return", {});

            case 16:
              _context20.prev = 16;
              _context20.t0 = _context20["catch"](0);
              return _context20.abrupt("return", {
                error: _context20.t0
              });

            case 19:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, this, [[0, 16]]);
    }));
  };

  this.constructCheckoutModel = function (_ref5) {
    var id = _ref5.id,
        token = _ref5.token,
        email = _ref5.email,
        shippingAddress = _ref5.shippingAddress,
        billingAddress = _ref5.billingAddress,
        discount = _ref5.discount,
        discountName = _ref5.discountName,
        voucherCode = _ref5.voucherCode,
        lines = _ref5.lines,
        availablePaymentGateways = _ref5.availablePaymentGateways,
        availableShippingMethods = _ref5.availableShippingMethods,
        shippingMethod = _ref5.shippingMethod;
    return {
      availablePaymentGateways: availablePaymentGateways,
      availableShippingMethods: availableShippingMethods ? availableShippingMethods.filter(utils_1.filterNotEmptyArrayItems) : [],
      billingAddress: billingAddress,
      email: email,
      id: id,
      lines: lines === null || lines === void 0 ? void 0 : lines.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.quantity) && item.variant.id;
      }).map(function (item) {
        var itemVariant = item === null || item === void 0 ? void 0 : item.variant;
        return {
          id: item.id,
          quantity: item.quantity,
          totalPrice: item === null || item === void 0 ? void 0 : item.totalPrice,
          variant: {
            attributes: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.attributes,
            id: itemVariant.id,
            name: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.name,
            pricing: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.pricing,
            product: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.product,
            quantityAvailable: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.quantityAvailable,
            sku: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.sku
          }
        };
      }),
      promoCodeDiscount: {
        discount: discount,
        discountName: discountName,
        voucherCode: voucherCode
      },
      shippingAddress: shippingAddress,
      shippingMethod: shippingMethod,
      token: token
    };
  };

  this.constructPaymentModel = function (_ref6) {
    var id = _ref6.id,
        gateway = _ref6.gateway,
        token = _ref6.token,
        creditCard = _ref6.creditCard,
        total = _ref6.total;
    return {
      creditCard: creditCard,
      gateway: gateway,
      id: id,
      token: token,
      total: total
    };
  };

  this.client = client;
});

exports.ApolloClientManager = ApolloClientManager;